import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem("ft-cookie-consent");
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);
  const decide = (val) => {
    localStorage.setItem("ft-cookie-consent", val);
    setVisible(false);
  };
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-[60] glass rounded-2xl p-5 shadow-2xl"
          data-testid="cookie-banner"
        >
          <div className="flex items-start gap-3">
            <Cookie className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-foreground leading-relaxed">
                We use cookies to enhance your experience and analyze site traffic. See our{" "}
                <Link to="/cookies" className="text-primary underline underline-offset-2">Cookie Policy</Link>.
              </p>
              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => decide("accepted")}
                  data-testid="cookie-accept"
                  className="rounded-full brand-gradient-bg text-white px-4 py-2 text-xs font-semibold hover:-translate-y-0.5 transition-transform"
                >
                  Accept all
                </button>
                <button
                  onClick={() => decide("rejected")}
                  data-testid="cookie-reject"
                  className="rounded-full glass px-4 py-2 text-xs font-semibold hover:border-primary/50 transition-colors"
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
